import { render, staticRenderFns } from "./cardButton.vue?vue&type=template&id=a2bff86e&scoped=true&"
import script from "./cardButton.vue?vue&type=script&lang=js&"
export * from "./cardButton.vue?vue&type=script&lang=js&"
import style0 from "./cardButton.vue?vue&type=style&index=0&id=a2bff86e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bff86e",
  null
  
)

export default component.exports